import { FormViewField } from 'components/FormView';
import React from 'react';

const HelpText = (helpText: string) => {
  if (!helpText) return (<React.Fragment></React.Fragment>);

  return (<p style={{ color: 'rgba(0, 0, 0, 0.87)', lineHeight: '1.46429em', fontSize: 15, paddingBottom: '1rem' }}>
    {helpText}
  </p>);
};

export default {
  formName: 'CustomerEnquiryFilterRow',
  validate: null,
  rowModelType: 'serverSide',
  parameters: [
    {
      id: 1,
      type: 'TEXT_FIELD',
      props: {
        label: 'Customer name',
        name: 'CustomerName',
        placeholder: '',
        size: 'medium',
      },
    },
    {
      id: 2,
      type: 'TEXT_FIELD',
      props: {
        label: 'Owner',
        name: 'Owner',
        size: 'medium'
      }
    },
    {
      id: 3,
      type: 'TEXT_FIELD',
      props: {
        label: 'Phone',
        name: 'Phone',
        placeholder: '',
        size: 'medium',
      },
    },
    {
      id: 4,
      type: 'TEXT_FIELD',
      props: {
        label: 'Postal address - city',
        name: 'City',
        placeholder: '',
        size: 'medium',
      },
    },
    {
      id: 5,
      type: 'TEXT_FIELD',
      props: {
        label: 'Postal address - state',
        name: 'State',
        placeholder: '',
        size: 'medium',
      },
    },
    {
      id: 6,
      type: 'TEXT_FIELD',
      props: {
        label: 'Postal address - postal code',
        name: 'PostalCode',
        placeholder: '',
        size: 'medium',
      },
    },
    {
      id: 7,
      visible: true,
      group: [
        {
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Customer account - from',
            name: 'AccountFrom',
            suppressValidation: true,
            isDisplayValue: true,
            size: 'small',
            helpTextComponent: HelpText,
            lookupName: 'Customer',
            style: {
              display: 'inline-block',
              width: '155px',
            }
          }
        },
        {
          type: 'EX_LOOKUP_FIELD',
          visible: true,
          props: {
            label: 'Customer account - to',
            suppressValidation: true,
            isDisplayValue: true,
            name: 'AccountTo',
            size: 'small',
            helpTextComponent: HelpText,
            lookupName: 'Customer',
            style: {
              display: 'inline-block',
              width: '155px',
            }
          }
        }
      ],
    },
    {
      id: 8,
      type: 'TOGGLE_FIELD',
      props: {
        label: 'Active only',
        name: 'Active',
        required: false
      },
    },
  ] as FormViewField[]
};
